import React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/tmp/35443907/node_modules/gatsby-theme-carbon/src/templates/Default.js";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const AnchorLinks = makeShortcode("AnchorLinks");
const AnchorLink = makeShortcode("AnchorLink");
const Row = makeShortcode("Row");
const Column = makeShortcode("Column");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h3 {...{
      "id": "a-disabled-state-is-applied-to-a-component-when-the-user-is-not-allowed-to-interact-with-the-component-due-to-either-permissions-dependencies-or-pre-requisites-disabled-states-completely-remove-the-interactive-function-of-a-component"
    }}>{`A `}<em parentName="h3">{`disabled state`}</em>{` is applied to a component when the user is not allowed to interact with the component due to either permissions, dependencies, or pre-requisites. Disabled states completely remove the interactive function of a component.`}</h3>
    <AnchorLinks mdxType="AnchorLinks">
      <AnchorLink mdxType="AnchorLink">Disabled variations</AnchorLink>
      <AnchorLink mdxType="AnchorLink">Default disabled</AnchorLink>
      <AnchorLink mdxType="AnchorLink">Read-only</AnchorLink>
      <AnchorLink mdxType="AnchorLink">Hidden</AnchorLink>
    </AnchorLinks>
    <h2 {...{
      "id": "disabled-variations"
    }}>{`Disabled variations`}</h2>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Variation`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><em parentName="td">{`Default disabled`}</em></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Cannot be clicked, selected or interacted with. It is not read by a screen reader and takes on the default disabled visual style.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><em parentName="td">{`Read-only`}</em></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`The user cannot interact with it but content is still readable and accessible to a screen reader. The visual style should contain no interactive indicators such as `}<inlineCode parentName="td">{`$interactive-01`}</inlineCode>{`, hover states, or text embellishments (i.e., underlines).`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><em parentName="td">{`Hidden`}</em></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`The component is completely hidden from view. The user does not know the option is there.`}</td>
        </tr>
      </tbody>
    </table>
    <h2 {...{
      "id": "default-disabled"
    }}>{`Default disabled`}</h2>
    <p>{`A `}<em parentName="p">{`default disabled`}</em>{` state is used when a component is temporarily disabled due to dependencies (when one piece of software relies on another one) or pre-requisites. This scenario is a temporary state change that is most commonly triggered by a user’s action or inaction. Once the dependencies have been resolved and/or the pre-requisites have been fulfilled, the default disabled component returns to its enabled state. In a temporarily disabled scenario the component should never fully disappear from the user’s view.`}</p>
    <Row mdxType="Row">
      <Column colLg={8} mdxType="Column">
        <span {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "1152px"
          }
        }}>{`
      `}<span parentName="span" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "49.32065217391305%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAKCAYAAAC0VX7mAAAACXBIWXMAAAsSAAALEgHS3X78AAABkElEQVQoz31SPU8CQRCdO1BDbClp7KhMtDBS2VCZ2Nj7K2zp7IyhJnRnLsZY8SNogAQLAwYxAQ6O7zs+g4bcZX27YTfoqZNsZnbezNs3u0sEGw6H3FGv16PRaESO49B0OqXFYiHyjDGFj8djcl2XZrMZxWIxkef7gJmmSf9Zs9n8NV8qlYJJqSSRSHA1e1j7m5Mvofiax77va/V6XYePrNfrSLlcDkPtLfAjjsNrinAwGMjRQrZt57BskL1gbA9NGVmHqznD2Baa3yDiHfgn4tMNoa4IW62WIoSK53a7zbrdrj+ZTBiwO1mHpvPVasXgGQjZfD7/gJjjACF/CEnY7/dfPc9jvJEblG4rvMC4bLlcCozHyJ0ECKFGEupQd2NZ1hNONjBuDgdcyTqMewjFj51Ox8RPeADZPeoPOIZb0v560J2fiWKxKHw0Gt2FCzTKb6Usm80qIJ1Ohw3DCCHW5JJ1qVRKR214G5NkAdJ4PP4tWSgUqNFoUK1WE/tkMqmwfD4v/iUekCqVishVq1XhvwAMHkwbQJ3k1AAAAABJRU5ErkJggg==')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="span" {...{
            "className": "gatsby-resp-image-image",
            "alt": "Default disabled example on the right",
            "title": "Default disabled example on the right",
            "src": "/static/b703dce65979fa385b218258f4110f88/fb070/disabled-1.png",
            "srcSet": ["/static/b703dce65979fa385b218258f4110f88/d6747/disabled-1.png 288w", "/static/b703dce65979fa385b218258f4110f88/09548/disabled-1.png 576w", "/static/b703dce65979fa385b218258f4110f88/fb070/disabled-1.png 1152w", "/static/b703dce65979fa385b218258f4110f88/c3e47/disabled-1.png 1472w"],
            "sizes": "(max-width: 1152px) 100vw, 1152px",
            "loading": "lazy"
          }}></img>{`
    `}</span>
      </Column>
    </Row>
    <h3 {...{
      "id": "style"
    }}>{`Style`}</h3>
    <p>{`Default disabled states are most commonly styled by a decrease in opacity with no hover state change and `}<inlineCode parentName="p">{`not-allowed`}</inlineCode>{` cursor applied. Refer to each individual component for the accurate disabled state.`}</p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Attribute`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Default disabled style`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><em parentName="td">{`Component`}</em></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`50% opacity`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><em parentName="td">{`Text`}</em></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`25% opacity`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><em parentName="td">{`Icons`}</em></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`50% opacity`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><em parentName="td">{`Hover`}</em></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`None`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><em parentName="td">{`Cursor`}</em></td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`not-allowed`}</inlineCode></td>
        </tr>
      </tbody>
    </table>
    <br />
    <Row mdxType="Row">
      <Column colLg={8} mdxType="Column">
        <span {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "1152px"
          }
        }}>{`
      `}<span parentName="span" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "49.32065217391305%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAKCAYAAAC0VX7mAAAACXBIWXMAAAsSAAALEgHS3X78AAABzElEQVQoz61Rv0/bYBC9zx9BgdDya+jef6AbEhIb6oAYShtwjFBst5WQgsLWLahZ+CfSJQxEGWoSyA8FO7bT0sEZ2sgSa7rQAjELWbq0g/tiIouidkE96cnP7757d7ojuh2v/ZDath1yy7JCXiwWg28ul6N8Ph/wQqHwpwnb+EH8xSXQIyHu0QPpAgmfTj5YMLOHsIImnU6HKpVKWF6v16nVagX5sDFTf03wlz+nZpIej4oen9445wPDjy1rDI9mDMPgzWZTgCGv1Wqs3W6PlEqlx9VqNeo4DsMbYQiiJ1vf6D6RSqWEfyYx1XZM8g4n1r390TVvP7Laq9HitdRx9BWjaWI48z26a5iwAeyAz5umeQRowAG0Q+Ad9PHAcCzhvZ2Vr748Uq9sGNsj8Z5LT683Xed47Vg32rquN1A4MPsE7KJwAWs4ga6jWwNwoRWxy3Fa2vlK/z3ikhKTkpuxvTOf5t5cssmVz2ygq4ocVRRlKpPJ8G63y3AI5vs+QYsAk8DDdDo9Orw2K5fLN4bPxFfCsoglP/cpEv9O06unga4oSYYins1mqd/vk6ZpNDCUZTnQVVXlOA5zXTfMUSKRCCcVRfGv/Pb/Xf2u9hvF8PYq5U+K7gAAAABJRU5ErkJggg==')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="span" {...{
            "className": "gatsby-resp-image-image",
            "alt": "Default disabled style examples",
            "title": "Default disabled style examples",
            "src": "/static/f1b6295dc34371e06bcb174c3c19ddb1/fb070/disabled-2.png",
            "srcSet": ["/static/f1b6295dc34371e06bcb174c3c19ddb1/d6747/disabled-2.png 288w", "/static/f1b6295dc34371e06bcb174c3c19ddb1/09548/disabled-2.png 576w", "/static/f1b6295dc34371e06bcb174c3c19ddb1/fb070/disabled-2.png 1152w", "/static/f1b6295dc34371e06bcb174c3c19ddb1/c3e47/disabled-2.png 1472w"],
            "sizes": "(max-width: 1152px) 100vw, 1152px",
            "loading": "lazy"
          }}></img>{`
    `}</span>
      </Column>
    </Row>
    <h3 {...{
      "id": "additional-warning"
    }}>{`Additional warning`}</h3>
    <p>{`An `}<a parentName="p" {...{
        "href": "/components/notification/code"
      }}>{`inline warning notification`}</a>{` can be shown in cases where a temporarily disabled item affects multiple items or the primary action of the flow. The notification should describe how the user can enable or re-enable the disabled component.`}</p>
    <Row mdxType="Row">
      <Column colLg={8} mdxType="Column">
        <span {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "1152px"
          }
        }}>{`
      `}<span parentName="span" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "50.27173913043478%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAKCAYAAAC0VX7mAAAACXBIWXMAAAsSAAALEgHS3X78AAACI0lEQVQoz21RS2sTURS+IKQZd4V2pC7Ejfsu3Cil2kV3/gw30RJBcKO4a92NLkJBiy4sqJSKXbQLJYjNQ1rbmNcimMRMMMa8J8ncyeRx8ziec3VKBQc+vvt9c+Y7Z+5h4+NL55v+2YuvHjJ159GZuberrrlPPuXc4YZbPdxQ1M9PFfX4+R8cPFPUyAtFTbx0z1LNt9fuGTiamoaDqWnzvWuGf3CdZZC9eXmQuXdjd9O75N/yLu9tepb9bzxL+9u3r+1v35II76wsftn1LoTerSwe7d1ZoPPHLc/1pP/uVfixNj/Kr85Xvt6/Uo09uMCqNWOt8PMXFAqFpq7neb1e552Ojehw2+5atm1LoHfCErbNLatjmdyyObfaYjgEZI0ZRuNJt9ulwHGxWIRqtQoYCqZpAgb8F1Tf7/dhMBhIoB4DPsjrDAu0v0LgeULA6Sanz6eBjSQymcwkEolMotHoJBaLDfL5PCD7WKVS0agjsqjVakCgKUulEpTLZXA8Amn8E/kukUhAIBCAUCgEwWBQYDCEw2EfS6fTmq7rkEqlBHEul4NsNkvdIJlMguMRk47H4zK81WpBs9mEdrsNlmUJnB5wSh9DUxNCgGEYgnMu745AUzYaDXA8Yrpb8umMIdKnQAwXdG2o1xkKbTQaUTcZ6ATQx9jkn0BqQHCakkc12EQGon7McFsnSxni6p3N0QS0UZreAWny6b3j9Xo98uSWcbDvvwFxrJ+FK6pTEwAAAABJRU5ErkJggg==')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="span" {...{
            "className": "gatsby-resp-image-image",
            "alt": "Additional warning with default disabled example",
            "title": "Additional warning with default disabled example",
            "src": "/static/23d98ebd3647ec1f05c1e98216fd84fc/fb070/disabled-3.png",
            "srcSet": ["/static/23d98ebd3647ec1f05c1e98216fd84fc/d6747/disabled-3.png 288w", "/static/23d98ebd3647ec1f05c1e98216fd84fc/09548/disabled-3.png 576w", "/static/23d98ebd3647ec1f05c1e98216fd84fc/fb070/disabled-3.png 1152w", "/static/23d98ebd3647ec1f05c1e98216fd84fc/c3e47/disabled-3.png 1472w"],
            "sizes": "(max-width: 1152px) 100vw, 1152px",
            "loading": "lazy"
          }}></img>{`
    `}</span>
      </Column>
    </Row>
    <h2 {...{
      "id": "read-only"
    }}>{`Read-only`}</h2>
    <p>{`In scenarios where the content of a disabled component or element is still relevant to the user or important to task completion, then the `}<em parentName="p">{`read-only`}</em>{` variation is used. This allows the user to read the information but not interact with or change it. Read-only content should always be accessible to a screen reader.`}</p>
    <h3 {...{
      "id": "style-1"
    }}>{`Style`}</h3>
    <p>{`The visual style of the read-only states vary by component but should never contain any interactive indicators such as `}<inlineCode parentName="p">{`$brand-01`}</inlineCode>{` color usage, hover states, or text embellishments (i.e., underlines).`}</p>
    <h2 {...{
      "id": "hidden"
    }}>{`Hidden`}</h2>
    <p>{`The `}<em parentName="p">{`hidden disabled`}</em>{` variation is used when something or someone does not have permission to view, interact with, or take action on an element of the UI. This variation completely hides the component, page, action, etc. from the user’s interface. The only way to enable the hidden element and have it resurfaced on the UI is to change the assigned permission.`}</p>
    <p>{`For example, when a user is the organization owner they are allowed to add members to the organization. Any users that are not an organization owner would not be shown the “Add member” button on a team directory page. Once the user is made an organization owner, `}<strong parentName="p">{`then and only then`}</strong>{` will the button be visible.`}</p>
    <Row mdxType="Row">
      <Column colLg={8} mdxType="Column">
        <span {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "1152px"
          }
        }}>{`
      `}<span parentName="span" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "53.53260869565217%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAALCAYAAAB/Ca1DAAAACXBIWXMAAAsSAAALEgHS3X78AAABmklEQVQoz3VSPWsCQRCdu4CkSm+TJl3APxFC/kGuSHEgJ3ZJGUj+iJCAWhypg5VgGgsRgwQsTJpTwe9vjeIJJ7p5u9yau5gbGN6y783bmd2l4XBIPLrdLs3n831OJhMajUYkg+u8/Hg8FhrJ+aJer1NQ1Go1sm07kD8wm81mAi3LUhhjIeSxK7xCFw98PZ1OlcFgIPjdbid4dG+A1/kaqO4N+/2+whEFZ1hXer1eZbFYvH8jYPQidTC4BGdB97FcLjnvgH90mzryGqouRiBiELHVasV4QPjkGe16s9kw6PY87vDuP0PFxXN04DSbTQdor9drhlGePYbadrtl6JChQ2l4H9ghTCL8ZC6WBRjTlDr8gotWq/UFXQkGJZh9wvzGvY7fO4RIcfG03W5nOp1OBmO/It9QcMs5x3HUoFfGuYE/gBuH/m42Gg2B0Wg0FIvFTmDAX5tkHpjm83mBxWKRcrmcWq1WVbdIoNQZhkHxeFxJJBJkmial02lKJpOCS6VS/i7C4bBvhGw2S+VymQqFgtjTdd2n1zQtcMwfXiByobQoZlsAAAAASUVORK5CYII=')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="span" {...{
            "className": "gatsby-resp-image-image",
            "alt": "Example of hidden disabled content on the right",
            "title": "Example of hidden disabled content on the right",
            "src": "/static/dd0f08b9df150798e58ad3981f1ed039/fb070/disabled-4.png",
            "srcSet": ["/static/dd0f08b9df150798e58ad3981f1ed039/d6747/disabled-4.png 288w", "/static/dd0f08b9df150798e58ad3981f1ed039/09548/disabled-4.png 576w", "/static/dd0f08b9df150798e58ad3981f1ed039/fb070/disabled-4.png 1152w", "/static/dd0f08b9df150798e58ad3981f1ed039/c3e47/disabled-4.png 1472w"],
            "sizes": "(max-width: 1152px) 100vw, 1152px",
            "loading": "lazy"
          }}></img>{`
    `}</span>
      </Column>
    </Row>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      